
import React, { FC, ReactNode } from 'react'; 
import Modal from 'react-bootstrap/esm/Modal';
import './CbdModal.scss'
type AllowedSize = 'lg' | 'sm' | 'xl' | undefined;

interface propsType {
    showModal:boolean,
    closeModal: () => void,
    title: string,
    size?: AllowedSize,
    children: ReactNode
}
const CbdModal:FC<propsType> = ({ showModal, closeModal, title, size, children }) => {  
    return ( 
        <Modal show={showModal} size={size} onHide={closeModal} dialogClassName="cbdmodal">
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body> 
        </Modal>
    )
}

export default CbdModal 
